
import React, { useEffect } from 'react'

import { useProject } from '@/Hooks/UseProject'
import { useChat } from '@/Hooks/UseChat'

import navigation from '@/navigation'

import HeaderForProject from '@/Layouts/MainLayout/components/HeaderForProject'
import HeaderSubMenu from '@/Layouts/MainLayout/components/HeaderSubMenu'
import MainSidebar from '@/Layouts/MainLayout/components/MainSidebar'
import PendingInvite from './components/PendingInvite/PendingInvite'

import '@/Layouts/MainLayout/MainLayout.scss'

interface Props {
  menuName: string
  subMenuName?: string
  hideSubMenu?: boolean
  children: any
}

const ProjectLayout = ({ menuName, subMenuName, hideSubMenu = false, children }: Props) => {

  const { setActiveProject } = useChat()
  const { project_id, project } = useProject()

  const [ menu, submenu ] = navigation.getNavigation(
    project_id || '',
    menuName,
    subMenuName || '',
  )

  useEffect(() => {

    if (project_id) setActiveProject(project_id);
  }, [project_id])

  return (
    <div className={`main-layout app-admin-wrap layout-horizontal-bar pl4-project-page pl4-project-page--${menuName}`}>
      <HeaderForProject menu={[]} />
      <div className="pl4-shell-workspace">
        <MainSidebar menu={menu} />
        <div className="pl4-shell-main">
          {!hideSubMenu && <HeaderSubMenu submenu={submenu} />}
          <div className="main-content-wrap d-flex flex-column">
            <div className="main-content-shadow" />
            <div className="main-content">
              <div className="page-content-body">
                {project._id && project.pendingInvite && (
                  <PendingInvite
                    invite={project.pendingInvite}
                  />
                )}
                {((project._id && !project.pendingInvite) || !project_id) && children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectLayout
